import { useContext } from "react";
import ClientGroup from "../groups/clientCardGroup";
import IndustryGroup from "../groups/industryGroup";
import PageTitle from "./pageTitle";
import ContactForm from "../cards/contactForm";
import MailSubscription from "../cards/emailSub";
import TextTemplate from "../cards/sampleText";
import Technologies from "../groups/techGroup";
import ServiceGroup from "../groups/serviceCardGroup";
import Aboutcard from "../cards/AboutCard";
import WorkProcessGroup from "../groups/workProcessGroup";
import { CoreValuesContext, TechContext } from "../../App";
import { Helmet } from "react-helmet-async";

const About = () => {
    const tech = useContext(TechContext);
    const coreValue = useContext(CoreValuesContext);

    // Filter out mission from TextTemplate as it is prominently featured in Aboutcard
    const otherCoreValues = Array.isArray(coreValue)
        ? coreValue.filter((item: any) => !item?.title?.toLowerCase?.().includes("mission"))
        : [];

    return (
        <>
            <Helmet>
                <title>About - Codehub Technologies</title>
            </Helmet>

            <PageTitle title="About" />

            {/* About Codehub Technologies Section */}
            <Aboutcard />

            {/* Core Values list */}
            {otherCoreValues.length === 0 ? null : (
                <TextTemplate dataList={otherCoreValues} />
            )}

            {/* Work Process Section */}
            <WorkProcessGroup />

            <ServiceGroup type={false} />

            {/* Technologies list */}
            {Object.keys(tech || {}).length === 0 ? null : (
                <Technologies techList={tech} />
            )}

            <IndustryGroup />
            <ClientGroup />
            <MailSubscription />
            <ContactForm />
        </>
    );
};

export default About;
